import { createContext, useContext, useState, ReactNode } from 'react';
import { AutomationContextValue, AutomationModalPane } from '../types';
import { AutomationModalPaneOptions } from '../enums';

interface AutomationProviderProps {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
}

export const AutomationContext = createContext<AutomationContextValue | null>(null);

export const AutomationProvider = ({ children, onClose, open }: AutomationProviderProps) => {
  const [currentPane, setCurrentPane] = useState<AutomationModalPane>(
    AutomationModalPaneOptions.CREATE
  );

  const value: AutomationContextValue = {
    open,
    onClose,
    onChangeModalPane: setCurrentPane,
    currentPane,
  };

  return <AutomationContext.Provider value={value}>{children}</AutomationContext.Provider>;
};

export const useAutomation = (): AutomationContextValue => {
  const context = useContext(AutomationContext);
  if (!context) {
    throw new Error('useAutomation must be used within an AutomationProvider');
  }
  return context;
};
